function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.9688 1.40625H1.03125C0.867188 1.40625 0.75 1.28906 0.75 1.125V0.375C0.75 0.234375 0.867188 0.09375 1.03125 0.09375H10.9688C11.1094 0.09375 11.25 0.234375 11.25 0.375V1.125C11.25 1.28906 11.1094 1.40625 10.9688 1.40625ZM10.9688 5.15625H1.03125C0.867188 5.15625 0.75 5.03906 0.75 4.875V4.125C0.75 3.98438 0.867188 3.84375 1.03125 3.84375H10.9688C11.1094 3.84375 11.25 3.98438 11.25 4.125V4.875C11.25 5.03906 11.1094 5.15625 10.9688 5.15625ZM10.9688 8.90625H1.03125C0.867188 8.90625 0.75 8.78906 0.75 8.625V7.875C0.75 7.73438 0.867188 7.59375 1.03125 7.59375H10.9688C11.1094 7.59375 11.25 7.73438 11.25 7.875V8.625C11.25 8.78906 11.1094 8.90625 10.9688 8.90625Z",
  fill: "#E39725"
});

var SvgNoChangeIconLight = function SvgNoChangeIconLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoChangeIconLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NoChangeIconLight.021901fd.svg";
export { ForwardRef as ReactComponent };